import { brokerLeadOffer, type BrokerLeadOffer } from "./broker-lead-offer";
import type { BrokerLeadLanding } from "./broker-lead-landing";

export function neutralBrokerLeadLanding(
  language: string,
  offer: BrokerLeadOffer = "BROKER_CONSULTATION",
): BrokerLeadLanding {
  const es = language === "es";
  if (offer === "FREE_VALUATION")
    return {
      version: 1,
      offer,
      language: es ? "es" : "en",
      headline: es
        ? "¿Cuánto podría valer tu negocio?"
        : "What could your business be worth?",
      description: es
        ? "Responde preguntas sobre tu negocio y comparte tus datos de contacto para ver una estimación gratuita y sus motivos. Tu corredor recibe tus respuestas y podrá contactarte. Confidencial y sin compromiso."
        : "Answer questions about your business and share your contact details to see a free estimate and the reasons behind it. Your broker receives your answers and may follow up. Confidential, with no commitment.",
    };
  return {
    version: 1,
    offer: "BROKER_CONSULTATION",
    language: es ? "es" : "en",
    headline: es
      ? "Hablemos de tus próximos pasos"
      : "Let’s talk about your next steps",
    description: es
      ? "Responde unas preguntas para solicitar una conversación confidencial con tu corredor. Tus respuestas le ayudan a prepararse; al enviarlas, podrá contactarte para hablar de tus opciones. Sin compromiso."
      : "Answer a few questions to request a confidential conversation with your broker. Your answers help them prepare; after you submit, they can contact you to discuss your options. No commitment.",
  };
}

export function brokerLeadLandingForLocale(
  intro: BrokerLeadLanding | null | undefined,
  locale: string,
): BrokerLeadLanding {
  return intro?.language === locale
    ? intro
    : neutralBrokerLeadLanding(locale, brokerLeadOffer(intro?.offer));
}
